export { SmartChoiceWidgetApp } from './SmartChoiceWidget';

// Export event utilities for parent applications to listen to preference changes
export {
  SMART_CHOICE_EVENTS,
  dispatchSmartChoiceEvent,
  createSmartChoiceEventHandler,
  createSmartChoiceErrorHandler,
} from '../../utils/smartChoiceEvents';

export type {
  SmartChoiceEventName,
  SmartChoicePreferencesEventDetail,
  SmartChoiceErrorEventDetail,
  RecommendationPreferencesData,
  SmartChoiceEventListener,
  SmartChoiceErrorEventListener,
} from '../../utils/smartChoiceEvents';

